export default {
  App: {
    DarkMode: 'app.darkMode',
    Locale: 'app.locale',
    SwapSlippage: 'app.swapSlippage',
    SwapLiquidity: 'app.swapLiquidity',
    SwapDeadline: 'app.swapDeadline',
    EthereumTxType: 'app.ethereumTxType',
    TermsAccepted: 'app.termsAccepted',
  },
  Swap: {
    Gasless: 'swap.gasless',
  },
  UserSettings: {
    Currency: 'userSettings.currency',
  },
  TokenLists: {
    Toggled: 'tokenLists.toggled',
  },
  Transactions: 'transactions',
};
